// extracted by mini-css-extract-plugin
export default {"hra__cards":"card_hra__cards__8dgZs","hra__url":"card_hra__url__TCGFR","hra__icons":"card_hra__icons__YJygp","hra__text":"card_hra__text__nnzBc"};